import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import {Router} from "@angular/router";
import {FunctionService} from "../demo/service/function.service";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    menu: MenuItem[] = [];

    @ViewChild('searchinput') searchInput!: ElementRef;

    @ViewChild('menubutton') menuButton!: ElementRef;

    searchActive: boolean = false;

    user:any;
    existUser = false;

    constructor(public layoutService: LayoutService,
                private router: Router,
                private functions: FunctionService) {}

    ngOnInit(){
        if (this.functions.getLocallData()) {
            this.user = this.functions.getLocallData();
             console.log(this.user)
            this.existUser = true;
        } else {
            this.existUser = false;
        }
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    deactivateSearch() {
        this.searchActive = false;
    }

    removeTab(event: MouseEvent, item: MenuItem, index: number) {
        this.layoutService.onTabClose(item, index);
        event.preventDefault();
    }

    get layoutTheme(): string {
        return this.layoutService.config.layoutTheme;
    }

    get colorScheme(): string {
        return this.layoutService.config.colorScheme;
    }

    get logo(): string {
        const path = 'assets/layout/images/logogim.png';
        const logo = (this.layoutTheme === 'primaryColor'  && !(this.layoutService.config.theme  == "yellow")) ? 'light.png' : (this.colorScheme === 'light' ? 'dark.png' : 'light.png');
        return path;
    }

    get tabs(): MenuItem[] {
        return this.layoutService.tabs;
    }

    signOut() {
        this.functions.clearLocalData();
        this.router.navigate(["./auth/login"]);
    }
}
